import Auth from './Auth'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function(Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(Auth)

    //2.用new 的方式用组件构造器创建出来组件对象
    const auth = new Construct({ store, router })

    //3.将组件对象手动挂载到某一个元素上
    auth.$mount(document.createElement('div'))

    //4.auth.$el对应的就是div
    document.body.appendChild(auth.$el)

    //5.在原型中加入Auth
    Vue.prototype.$Auth = auth
}

export default obj
